import i from "./ghl-ui.es193.js";
const h = ({
  path: n,
  options: t,
  pathSeparator: l = "/"
}) => {
  const o = n.split(l).filter(Boolean);
  let e = t;
  for (const r of o) {
    const s = e.find((c) => c.value === r);
    if (!s)
      return null;
    e = s.children || [];
  }
  return i(e, "value");
}, d = (n, t) => {
  console.log(n, t);
}, g = (n) => {
  const t = [], l = (o, e = "/") => {
    const { label: r, value: s, children: c, ...u } = o, a = { label: r, value: s, _pathFromRoot: e, ...u };
    c ? (t.push({ ...a, type: "parent" }), c.forEach((f) => l(f, `${e}${r}/`))) : t.push(a);
  };
  return n.forEach((o) => l(o)), i(t, "value");
};
export {
  g as getFlattenedOptions,
  h as getObjectByPath,
  d as showDebugging
};
